export default "__VITE_ASSET__DpftNIzQ__"